$(document).ready(function () {
  // Reviews scroller dots
  function initReviewsDots() {
    const $scroller = $(".pdp-main_stat_reviews_scroller");
    const $dots = $(".pdp-main__static_dot");
    const $cells = $(".pdp-main_stat_review_cell");

    if (!$scroller.length || !$dots.length || !$cells.length) return;

    $dots.on("click", function () {
      const index = $(this).data("index") - 1;
      const cell = $cells[index];
      if (cell) {
        $scroller[0].scrollTo({ left: cell.offsetLeft, behavior: "smooth" });
      }
    });

    $scroller.on("scroll", function () {
      const scrollLeft = this.scrollLeft;
      let closest = 0;
      let minDist = Infinity;
      $cells.each(function (i) {
        const dist = Math.abs(this.offsetLeft - scrollLeft);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      $dots.removeClass("active").eq(closest).addClass("active");
    });
  }

  initReviewsDots();
});